import axios from 'axios';

/** The backend's message for a failed call (`error`/`detail`, or DRF field errors). */
export function errorText(e: unknown): string {
  if (axios.isAxiosError(e)) {
    const body = e.response?.data as Record<string, unknown> | undefined;
    if (body?.error || body?.detail) return String(body.error ?? body.detail);
    if (body && typeof body === 'object') {
      // DRF field errors: {"name": ["This field is required."]}
      return Object.entries(body).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(' ') : v}`).join('; ');
    }
  }
  return (e as Error).message;
}
